import { excludeParticipant } from '@/api/project';
import { handleError } from '@/actions/common';
import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import { runBulk } from '../utils';

export default async (code: string, participants: string[]): Promise<void> => {
  try {
    const ids = await runBulk(
      participants,
      (uid) => excludeParticipant(code, uid).then(() => uid),
      (e) => handleError(e)
    );
    
    store.dispatch(
      projectSlice.actions.removeParticipants({
        code,
        ids,
      })
    );
  } catch (error) {
    handleError(error);
    throw error;
  }
};